import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[appDebounceClick]'
})
export class DebounceClickDirective implements OnInit, OnDestroy {
  @Input() debounceTime = 5000;
  @Output() debounceClick = new EventEmitter();
  private locked:boolean = false;
  constructor() { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    if(this.locked || !this.debounceClick){
      return;
    }
    this.locked = true;
    event.preventDefault();
    event.stopPropagation();
    this.debounceClick.emit(event);
    setTimeout(()=>{
      this.locked = false;
    }, this.debounceTime);
  }
}
